import { TeilnehmerVO } from "@core/api/v1";
import AnredeEnum = TeilnehmerVO.AnredeEnum;

export const anredeOptionen: { label: string, value: AnredeEnum }[] = [
    { label: 'Herr', value: AnredeEnum.HERR },
    { label: 'Frau', value: AnredeEnum.FRAU }
];
